import React, { useEffect, useState } from 'react'
import { Header } from '../../components/Header/Header'
import DataTable from 'react-data-table-component'
import { CSVLink } from 'react-csv'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link } from 'react-router-dom'
import { MdEdit } from 'react-icons/md'

export const Report = () => {
  // report generation of the latest requests based on year and month filter
  const currentDate = new Date().toISOString().split('T')[0]

  useEffect(() => {
    var nav_item = document.getElementById('hrHome')
    nav_item.classList.add('navlinkactive')
  }, [])

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [filteredData, setFilteredData] = useState([])
  const [values, setValues] = useState({
    from: '',
    to: '',
    status: '',
  })

  // onchange input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'hr-approval/getAllRequests')
      .then((res) => {
        setData(res.data.data)
        setFilteredData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // filter data based on dropdown selection
  useEffect(() => {
    const result = data.filter((item) => {
      const range = moment(new Date(item.initiate_date)).format('YYYY-MM-DD')
      if (values.from === '' || values.to === '') {
        return (
          item.status.match(values.status) &&
          item.payee_name.toLowerCase().match(search.toLowerCase())
        )
      } else if (values.from !== '' && values.to !== '') {
        return (
          moment(range).isBetween(values.from, values.to, null, '[]') &&
          item.status.match(values.status) &&
          item.payee_name.toLowerCase().match(search.toLowerCase())
        )
      }

      return false
    })

    setFilteredData(result)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, search])

  // columns to display data table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.transaction_id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Employee Name',
      selector: (row) => {
        return (
          <Tippy content={row.payee_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.payee_name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },
    {
      name: 'Employee ID',
      selector: (row) => row.desig_id,
      width: '130px',
    },

    // {
    //   name: 'Employee Department',
    //   selector: (row) => {
    //     return (
    //       <Tippy content={row.dept_name} theme="bootstrap">
    //         <p
    //           style={{
    //             marginTop: '1rem',
    //           }}
    //           className="text-truncate"
    //         >
    //           {row.dept_name}
    //         </p>
    //       </Tippy>
    //     )
    //   },
    //   width: '180px',
    // },
    {
      name: 'Paid Amount',
      selector: (row) => row.paid_amount,
    },
    {
      name: 'Payment Mode',
      selector: (row) => row.mode_name,
    },
    {
      name: 'Employee Status',
      selector: (row) => row.employee_status,
    },
    {
      name: 'HR Status',
      selector: (row) => row.status,
    },
    {
      name: 'Final Status',
      selector: (row) => row.final_status,
    },
    {
      name: 'Initiated Date',
      selector: (row) => {
        return moment(
          new Date(row.initiate_date).toISOString().split('T')[0],
        ).format('DD-MM-YYYY')
      },
    },
    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            {/* to edit and delete request */}
            <Link to={'/editRequest/' + row.transaction_id} className="link">
              <MdEdit className="editbtn" />
            </Link>
          </>
        )
      },
    },
  ]

  // to store current page index of dataTable
  const onPageChange = (pageIndex) => {
    global.reportPageNumber = pageIndex
  }

  return (
    <>
      <Header />
      <div className="container report p-4">
        <div className="w-100  d-flex justify-content-end">
          <div className="row w-75">
            <div className="col-md-3">
              <input
                type="text"
                placeholder="Search Here..."
                className="mt-4 form-control"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value)
                  onchange()
                }}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                From
              </h6>
              <input
                type="date"
                className="form-control"
                name="from"
                value={values.from}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                To
              </h6>
              <input
                type="date"
                className="form-control"
                name="to"
                value={values.to}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                Status
              </h6>
              <select
                className="form-select"
                id="floatingSelectGrid"
                name="status"
                value={values.status}
                onChange={handleChange}
              >
                <option value="" disabled selected>
                  {' '}
                  Select{' '}
                </option>
                <option value="Approved"> Approved </option>
                <option value="Pending"> Pending </option>
                <option value="On Hold"> On Hold </option>
                <option value="Rejected"> Rejected </option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <div className="d-flex align-items-end justify-content-end mb-4 mt-2">
            {/* export data in csv format */}
            <CSVLink
              data={filteredData}
              filename={'Reimbursement requests - ' + currentDate}
            >
              <button className="btn btn-primary btn-sm" type="button">
                Export
              </button>
            </CSVLink>
            <button
              className="btn btn-outline-secondary mx-2 btn-sm"
              type="button"
              onClick={() => {
                setValues({ from: '', to: '', status: '' })
                setSearch('')
                getData()
              }}
            >
              Clear
            </button>
          </div>
        </div>
        {/* data table */}
        <DataTable
          title="Latest Requests"
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          onChangePage={onPageChange}
          paginationDefaultPage={
            global.reportPageNumber ? global.reportPageNumber : 1
          }
        />
      </div>
    </>
  )
}
